'use es6';

export const ROW_LIMITS = {
  FIFTEEN: 15,
  THIRTY: 30,
  SIXTY: 60,
  NINETY: 90
};